import { render, staticRenderFns } from "./SectionGroup.vue?vue&type=template&id=f90cf580"
import script from "./SectionGroup.vue?vue&type=script&lang=js"
export * from "./SectionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports